import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '@shared/services/user.service';
import { matchRule } from '@core';
import { LoginService } from './login.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { AuthService } from './auth.service';

const routesPermissionsConfig = require("@configs/routes-permissions.json");


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  routes: any;

  constructor(private loginService: LoginService, private auth: AuthService,
    private router: Router, private userService: UserService) {
    this.routes = routesPermissionsConfig.routes;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    // if (environment.skipLogin) {
    //   return true;
    // }

    const isPublic = route.data['public'];

    return this.loginService.refresh(this.canAccessToPage.bind(this, state.url, isPublic), isPublic);

  }

  private canAccessToPage(path: string, isPublic: boolean = false) {

    if (!this.auth.isLogged()) {
      return isPublic;
    }

    if (path == '/index') {
      this.router.navigate(['/home']);
      return false;
    }

    for (let route in this.routes) {
      if (matchRule(path, route)) {
        return this.routes[route].permissions
          .reduce((isEnable, permission) => isEnable || this.userService.isPermissionEnable(permission), false);
      }
    }
    return true;
  }
}
